import { useState } from "react";

import { InvoiceLineItems } from "../../interfaces/Gig";
import AddAndEditInvoiceLineItem from "./AddAndEditInvoiceLineItem";
import DisplayInvoiceLineItem from "./DisplayInvoiceLineItem";

interface InvoiceLineItemProps {
  invoiceData: InvoiceLineItems;
  handleInvoiceDelete: () => void;
  handleInvoiceEdit?: (data: InvoiceLineItems) => void;
}
const InvoiceLineItem = ({
  invoiceData,
  handleInvoiceDelete,
  handleInvoiceEdit,
}: InvoiceLineItemProps) => {
  const [canEdit, setCanEdit] = useState(false);

  return (
    <>
      {!canEdit ? (
        <DisplayInvoiceLineItem
          invoiceData={invoiceData}
          handleDelete={handleInvoiceDelete}
          handleEdit={() => {
            setCanEdit(true);
          }}
        />
      ) : (
        <AddAndEditInvoiceLineItem
          invoiceData={invoiceData}
          handleInvoiceEdit={handleInvoiceEdit}
          enableDisplayMode={() => {
            setCanEdit(false);
          }}
        />
      )}
    </>
  );
};

export default InvoiceLineItem;
